const SelectBoxCustomOptionLabel = {
    option: (provided:any, state:any) => (
        {
            ...provided,
            // borderBottom: '1px solid #F0FBFB',
            color: state.isSelected ? 'white' : '#3A3A3A',
            background: state.isSelected ? "none": "none",
            padding: 10,
            ":hover" : {
                background: "none",
            },
            ":last-child" : {
                borderBottom: 'none',
            },
            ":blur": {
                backgroundColor: "none",
            },
        }
    ),
    indicatorSeparator: (provided:any)=>({
        border: "none",
    }),
    container: (provided:any, state:any)=>({
        ...provided,
        outline:"none",
    }),
    control: (provided:any)=>({
        ...provided,
        borderRadius: "15px",
        marging: "0px",
        outline:"none",
        border: "none",
        boxShadow: "-4px 5px 10px 2px rgba(102, 207, 200, 0.3)",
        padding: "0px 8px",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "21px",
        color: "#3A3A3A",
        appearance: "none",
        "MozAppearance": "none",
        "WebkitAppearance": "none",
        position: "relative",
        width: "100%",
        whiteSpace: "no-wrap",
        height: "48px",
        ":focus": {
            outline: "none",
            border: "none",
        },
        ":hover": {
            outline: "none",
            border: "none",
        },
    }),
    dropdownIndicator: (base:any, state:any) => ({
        ...base,
        ":before": {
            border: "none",
        },
        ":hover": {
            color: "#66CFC8",
        },
        "svg": {
            height: 25,
            width: 25,
          },
        fontFamily: "Font Awesome 6 Free",
        fontWeight: 900,
        fontSize: "14px",
        color: "#66CFC8",
        transition: "all .2s ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null
      }),
    // dropdownIndicator: (provided:any)=>({
    //     ":before": {
    //         border: "none",
    //     },
    //     fontFamily: "Font Awesome 6 Free",
    //     fontWeight: 900,
    //     fontSize: "14px",
    //     color: "#66CFC8",
    // }),
    menu: (provided:any, state:any) => (
        {
            ...provided,
            width: "100%",
            color: state.selectProps.menuColor,
            padding: "16px ",
            borderRadius: "15px",
            left: 0,
            background: "#FFFFFF",
            boxShadow: "-4px 5px 10px 2px rgba(102, 207, 200, 0.3)",
            zIndex: "999",
            marginTop: "8px",
            position: 'relative',
            // animation: state.selectProps.menuIsOpen ? "fadeIn 1s ease-in-out" : "fadeOut 1s ease-in-out",
        }
    ),
    menuList: (provided: any) => ({
        ...provided,
        maxHeight: "430px",
        scrollbarWidth: "thin",
    }),
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
}

export default SelectBoxCustomOptionLabel;